// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { entityURLForCohort } from 'utils/cohort-utils';
import './ReportContainer.scss';
// import { MetricsPanel } from './metrics/MetricsPanel';
const BookingEntity = '1';
const PassengerEntity = '2';
const DriverEntity = '3';

const DataTable = (props: {header: Array<Object>, body: Array<Object>}) => {
  const {
    header,
    body,
  } = props;

  return (
    <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
      <DataTableHeader cols={header} />
      <DataTableBody rows={body} />
    </table>
  );
};

const DataTableHeader = (props: {cols: Array<Object>}) => {
  const header = props.cols;

  return (
    <thead>
      <tr>
        {_.map(header, cell => (
          <TH key={cell}>{cell}</TH>
        ))}
      </tr>
    </thead>
  );
};

const DataTableBody = (props: {rows: Array<Object>}) => {
  const body = props.rows;

  return (
    <tbody>
      {_.map(body, row => (
        <tr>
          {_.map(row, cell => (
            <TD key={cell}>{cell}</TD>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

const TD = (props: {children: Object}) => <td>{props.children}</td>;
const TH = (props: {children: Object}) => <th>{props.children}</th>;

type Props = {
  details: Object,
};

type State = {
  activeResourceTab: string
};

class ReportContainer extends Component {
  static generateEntityURLLink(entityId, entityType) {
    switch (entityType) {
      case BookingEntity:
        return <a
          href={`${entityURLForCohort()}/bookings/${entityId}`}
          target="_blank"
          title="View Booking in Gamma"
          aria-label="View Booking in Gamma"
          rel="noopener noreferrer"
        >
          <span className="icon is-small" aria-hidden="true">
            <i className="fa fa-external-link" />
          </span>
        </a>;
      case DriverEntity:
        return <a
          href={`${entityURLForCohort()}/drivers/${entityId}`}
          target="_blank"
          title="View Driver in Gamma"
          aria-label="View Driver in Gamma"
          rel="noopener noreferrer"
        >
          <span className="icon is-small" aria-hidden="true">
            <i className="fa fa-external-link" />
          </span>
        </a>;
      case PassengerEntity:
        return <a
          href={`${entityURLForCohort()}/passengers/${entityId}`}
          target="_blank"
          title="View Passenger in Gamma"
          aria-label="View Passenger in Gamma"
          rel="noopener noreferrer"
        >
          <span className="icon is-small" aria-hidden="true">
            <i className="fa fa-external-link" />
          </span>
        </a>;
      default:
        return null;
    }
  }
  constructor(props: Props) {
    super(props);
    this.state = {
      activeResourceTab: 'bookings',
    };
  }

  state: State;

  compare = (a, b) => {
    if (a.message > b.message) {
      return 1;
    } else if (b.message > a.message) {
      return -1;
    }
    return 0;
  };

  loadResourceData() {
    if (!this.props.details) {
      return null;
    }
    const resourceType = this.state.activeResourceTab;
    const data = [];
    let {
      bookings,
      errors,
      driverIDs,
      passengerIDs,
    } = this.props.details;

    if (this.props.details && this.props.details.report) {
      bookings = this.props.details.report.bookingIDs;
      errors = this.props.details.report.errors;
      driverIDs = this.props.details.report.driverIDs;
      passengerIDs = this.props.details.report.passengerIDs;
    }

    switch (resourceType) {
      case 'bookings':
        data.push(
          <DataTable
            header={['Booking ID', 'Status', 'Gamma Info']}
            body={_.map(bookings, (state: string, bookingID: string) => [
              bookingID,
              state,
              (<a
                href={`${entityURLForCohort()}/bookings/${bookingID}`}
                target="_blank"
                title="View Booking in Gamma"
                aria-label="View Booking in Gamma"
                rel="noopener noreferrer"
              >
                <span className="icon is-small" aria-hidden="true">
                  <i className="fa fa-external-link" />
                </span>
              </a>),
            ])}
          />
        );
        break;
      case 'pax':
        data.push(
          <DataTable
            header={['No.', 'Passenger ID', 'Gamma Info']}
            body={_.map(passengerIDs, (pax, idx: number) => [
              idx + 1,
              pax,
              (<a
                href={`${entityURLForCohort()}/passengers/${pax}`}
                target="_blank"
                title="View Passenger in Gamma"
                aria-label="View Passenger in Gamma"
                rel="noopener noreferrer"
              >
                <span className="icon is-small" aria-hidden="true">
                  <i className="fa fa-external-link" />
                </span>
              </a>),
            ])}
          />
        );
        break;
      case 'dax':
        data.push(
          <DataTable
            header={['No.', 'Driver ID', 'Gamma Info']}
            body={_.map(driverIDs, (dax, idx: number) => [
              idx + 1,
              dax,
              (<a
                href={`${entityURLForCohort()}/drivers/${dax}`}
                target="_blank"
                title="View Driver in Gamma"
                aria-label="View Driver in Gamma"
                rel="noopener noreferrer"
              >
                <span className="icon is-small" aria-hidden="true">
                  <i className="fa fa-external-link" />
                </span>
              </a>),
            ])}
          />
        );
        break;
      case 'errors': {
        // Key: 1 represents booking error
        // Key: 2 represents passenger login error
        // Key: 3 represents driver login error
        const displayErrors = _.flatMap(errors, (errorTypeValues, errorTypeKeys: number) => {
          errorTypeValues.sort(this.compare);
          if (errorTypeValues.length > 0) {
            let err = errorTypeValues[0];
            const res = [{
              message: err.message,
              displayIds: [
                err.entityId,
                ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys),
              ] }];
            for (let i = 1; i < errorTypeValues.length; i += 1) {
              err = errorTypeValues[i];
              if (err.message === _.last(res).message) {
                _.last(res).displayIds.push(err.entityId);
                _.last(res).displayIds.push(ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys));
              } else {
                res.push({
                  message: err.message,
                  displayIds: [err.entityId, ReportContainer.generateEntityURLLink(err.entityId, errorTypeKeys)],
                });
              }
            }
            return res;
          }
          return [];
        });
        data.push(
          <DataTable
            header={['Error Message', 'ID']}
            body={_.map(displayErrors, errArray => [
              errArray.message,
              errArray.displayIds,
            ])
            }
          />
        );
        break;
      }
      default:
        break;
    }
    return (
      <div className="resource-viewer">
        {data}
      </div>
    );
  }

  calcStats() {
    const { details } = this.props;
    const ans = {
      totalBookings: 0,
      unallocatedBookings: 0,
      unknownBookings: 0,
      completedBookings: 0,
    };

    if (details && details.bookings) {
      _.forEach(details.bookings, (state) => {
        if (state === 'UNKNOWN') {
          ans.unknownBookings += 1;
        } else if (state === 'UNALLOCATED') {
          ans.unallocatedBookings += 1;
        } else if (state === 'COMPLETE') {
          ans.completedBookings += 1;
        }

        ans.totalBookings += 1;
      });
    } else if (details && details.report) {
      ans.totalBookings = details.report.totalBookings;
      ans.unallocatedBookings = details.report.unallocatedBookings;
      ans.unknownBookings = details.report.otherBookings;
      ans.completedBookings = details.report.successfulRides;
    }

    return ans;
  }

  handleResourceClick = (event: Event) => {
    this.setState({ activeResourceTab: (event.currentTarget: window.HTMLLIElement).dataset.value });
    this.loadResourceData();
  };

  props: Props;

  render() {
    let setPaxActive = 'resource-header';
    let setDaxActive = 'resource-header';
    let setErrorsActive = 'resource-header';
    let setBookingsActive = 'resource-header';
    const stats = this.calcStats();
    switch (this.state.activeResourceTab) {
      case 'errors':
        setErrorsActive += ' selected';
        break;
      case 'pax':
        setPaxActive += ' selected';
        break;
      case 'dax':
        setDaxActive = ' selected';
        break;
      case 'bookings':
        setBookingsActive = ' selected';
        break;
      default:
        break;
    }
    return (
      <div className="resource-container">
        <nav className="level">
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Total Bookings</p>
              <p className="title">{stats.totalBookings}</p>
            </div>
          </div>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Successful Rides</p>
              <p className="title">{stats.completedBookings}</p>
            </div>
          </div>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Unallocated Bookings</p>
              <p className="title">{stats.unallocatedBookings}</p>
            </div>
          </div>
          <div className="level-item has-text-centered">
            <div>
              <p className="heading">Others Bookings</p>
              <p className="title">{stats.unknownBookings}</p>
            </div>
          </div>
        </nav>
        <div className="htabs">
          <ul>
            <li data-value="bookings" onClick={this.handleResourceClick}>
              <div className={setBookingsActive} key="info-header">Bookings</div>
            </li>
            <li data-value="pax" onClick={this.handleResourceClick}>
              <div className={setPaxActive} key="pax-header">Passengers</div>
            </li>
            <li data-value="dax" onClick={this.handleResourceClick}>
              <div className={setDaxActive} key="dax-header">Drivers</div>
            </li>
            <li
              data-value="errors"
              onClick={this.handleResourceClick}
            >
              <div className={setErrorsActive} key="err-header">Errors</div>
            </li>
          </ul>
        </div>
        {this.loadResourceData()}
      </div>
    );
  }
}

ReportContainer.defaultProps = {
  report: {
    totalBookings: 0,
    successfulRides: 0,
    allocationRate: 0,
    successRate: 0,
    errors: [],
    passengerIDs: [],
    driverIDs: [],
    timeoutEvent: false,
    bookings: {},
  },
};

export default connect()(ReportContainer);



/** WEBPACK FOOTER **
 ** ./src/js/views/reports/ReportContainer.jsx
 **/